module.exports = {"530581001":"腾越街道","530581102":"固东镇","530581103":"滇滩镇","530581104":"猴桥镇","530581105":"和顺镇","530581106":"界头镇","530581107":"曲石镇","530581108":"明光镇","530581109":"中和镇","530581110":"芒棒镇","530581111":"荷花镇","530581201":"马站乡","530581202":"北海乡","530581203":"清水乡","530581204":"五合乡","530581205":"新华乡","530581206":"蒲川乡","530581207":"团田乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530581.json
// module id = 2713
// module chunks = 0